import ApiClient from './ApiClient';

class CatalogBannersAPI extends ApiClient {
  constructor() {
    super('catalog_banners', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  create(formData) {
    return axios.post(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  update(id, formData) {
    return axios.patch(`${this.url}/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new CatalogBannersAPI();
